import Enumerator from '../global/Enumerator';

export const contactResidentialStatusOptions = [
  'none',
  'own',
  'own_home_mortgage',
  'renting',
  'boarding',
  'with_parents',
  'other'
];

export class ContactResidentialStatusOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'own';
        break;
      case '2':
        correctOption = 'renting';
        break;
      case '3':
        correctOption = 'boarding';
        break;
      case '4':
        correctOption = 'with_parents';
        break;
      case '5':
        correctOption = 'other';
        break;
      case '6':
        correctOption = 'own_home_mortgage';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactResidentialStatusOption.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  own: {
    get title() {
      return 'Own';
    }
  },
  own_home_mortgage: {
    get title() {
      return 'Own Home - Mortgage';
    }
  },
  renting: {
    get title() {
      return 'Renting';
    }
  },
  boarding: {
    get title() {
      return 'Boarding';
    }
  },
  with_parents: {
    get title() {
      return 'With parents';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  contactResidentialStatusOptions,
  ContactResidentialStatusOption
};
